'use client';
import { Container, Stack, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icons } from '@peerless/ui-assets/icons';
import { useTranslations } from 'next-intl';

export const EmptyCartSlideoutBanner: React.FC = () => {
  const t = useTranslations();
  return (
    <Container sx={{ flex: '1', display: 'flex', justifyContent: 'center' }}>
      <Stack
        spacing={2}
        justifyContent={'center'}
        alignItems={'center'}
        sx={{ color: 'primary.main' }}
      >
        <FontAwesomeIcon icon={icons.cartEmpty} size="3x" />
        <Typography variant="h4" sx={{ color: 'common.black', marginTop: '.5rem !important' }}>
          {t('Cart.empty-cart-title')}
        </Typography>
      </Stack>
    </Container>
  );
};
